module.exports = __webpack_public_path__ + "static/media/Workout4.933402ea.png";